import ClassicQuizParticipationQuestionModel from "./ClassicQuizParticipationQuestionModel";

export default class ClassicQuizParticipationModel {
  public classicQuizId: string = null;
  public userId: string = null;
  public questions: ClassicQuizParticipationQuestionModel[] = [];
  public correctOptions: number = null;
  public personalBest: number = null;
  public points: number = null;
  public attempts: number = null;
}
